import { projectColumns, projectFieldNames } from "./form_fields_and_columns";
import { getProjectId } from "./functions";

export async function generateFormData(form, folderName, saveForExport = false) {
  const projectValues = [];
  for (const field of projectFieldNames) {
    if (form.elements[field] === undefined) {
      projectValues.push("");
      continue;
    }
    if (form.elements[field].type === "checkbox") {
      projectValues.push(form.elements[field].checked);
    } else {
      projectValues.push(form.elements[field].value);
    }
  }

  // these are custom selects, we need to get the id from the attribute data-id
  const fields = [
    "collection",
    "series",
    "theme",
    "article",
    "designer",
    "drawer",
    "puncher",
    "estimated",
    "discussed",
  ];
  for (const field of fields) {
    if (!projectColumns.includes(field + "_id")) {
      projectColumns.push(field + "_id");
    }
    const value = document.getElementById(field).getAttribute("data-id");
    if (value == null || value == "null") {
      projectValues.push(0);
    } else {
      projectValues.push(value);
    }
  }

  const yarnValues = await getYarnValues();
  const fabricValues = await getFabricValues();
  const sequinsValues = await generateSequinsData();

  const imageFile = document.getElementById("fileInput");
  let imageFileName = "";

  // Check if a file is selected
  if (imageFile.files.length > 0) {
    // Get the original file object
    const originalFile = imageFile.files[0];

    // Extract the file extension from the original file name
    const fileExtension = originalFile.name.split('.').pop();

    // Create a new file name "main.ext"
    const newFileName = 'main.' + fileExtension;

    // Create a new File object with the new name but the same content and type
    const renamedFile = new File([originalFile], newFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });

    // Use the new file name
    imageFileName = renamedFile.name; // This will be 'main.ext'

  } else {
    // No file is selected, check folderName for fallback

    imageFileName = folderName.includes("/")
      ? folderName.split("/")[1]
      : "";
  }


  folderName = folderName.includes("/")
    ? folderName.split("/")[0].split("folder-")[1]
    : folderName;

  const projectId = await getProjectId();
  const functionName = saveForExport
    ? "save_project"
    : projectId !== null
    ? "update_project"
    : "save_project";

  const version = saveForExport ? true : false;

  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify({
      function: functionName,
      columns: { project: projectColumns },
      values: {
        project: projectValues,
        yarn: yarnValues,
        fabric: fabricValues,
        sequins: sequinsValues,
        name: document.getElementById("project-name").textContent,
        id: projectId,
        version,
      },
      folder: folderName,
      image: imageFileName,
    })
  );

  return formData;
}

export async function getFabricValues() {

  const fabricContainer = document.querySelector(
    ".editor-content__form .fabric"
  );
  const fabricContainerChildren = fabricContainer.querySelectorAll("input");
  const values = [];
  for (let i = 0; i < fabricContainerChildren.length; i += 5) {
    if (fabricContainerChildren[i].value === "") continue;
    const lagecodeId = fabricContainerChildren[i + 1].getAttribute("data-id");

    values.push([
      fabricContainerChildren[i].value,
      fabricContainerChildren[i + 1].value,
      fabricContainerChildren[i + 2].value,
      fabricContainerChildren[i + 3].value,
      fabricContainerChildren[i + 4].value,
      lagecodeId,
    ]);
  }
  return values;

}

export async function getYarnValues() {
  const yarnContainer = document.querySelector("#yarn-container");
  const yarnContainerChildren = yarnContainer.querySelectorAll("input");
  const values = [];
  for (let i = 0; i < yarnContainerChildren.length; i += 5) {
    if (yarnContainerChildren[i].value === "") continue;
    const id = yarnContainerChildren[i].getAttribute("data-id");
    values.push([
      yarnContainerChildren[i].value,
      yarnContainerChildren[i + 1].value,
      yarnContainerChildren[i + 2].value,
      yarnContainerChildren[i + 3].value,
      yarnContainerChildren[i + 4].value,
      id,
    ]);
  }
  return values;
}

async function generateSequinsData() {
  const sequinsContainer = document.querySelector("#sequins-container");
  const sequinsContainerChildren = sequinsContainer.querySelectorAll("input");
  const values = [];
  for (let i = 0; i < sequinsContainerChildren.length; i += 4) {
    if (sequinsContainerChildren[i].value === "") continue;
    const id = sequinsContainerChildren[i].getAttribute("data-id");
    values.push([
      sequinsContainerChildren[i].value,
      sequinsContainerChildren[i + 1].value,
      sequinsContainerChildren[i + 2].value,
      sequinsContainerChildren[i + 3].value,
      id,
    ]);
  }
  return values;
}
